import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IconActionCompareAdd24, IconActionCompareAdded24 } from '@cian/ui-kit-design-tokens/icons';

import { ADD_TO_COMPARE_LABEL, COMPARE_BUTTON_DATA_MARK, REMOVE_FROM_COMPARE_LABEL } from './constants/compare';

interface ICompareButtonControlProps {
  isAdded: boolean;
  onClick(): void;
}

export function CompareButtonControl({ isAdded, onClick }: ICompareButtonControlProps) {
  return (
    <Button
      beforeIcon={isAdded ? <IconActionCompareAdded24 /> : <IconActionCompareAdd24 />}
      theme="stroke_secondary"
      size="M"
      onClick={onClick}
      data-mark={COMPARE_BUTTON_DATA_MARK}
      aria-label={isAdded ? REMOVE_FROM_COMPARE_LABEL : ADD_TO_COMPARE_LABEL}
    />
  );
}
